/* eslint-disable */
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Select from "react-select";
import config from "../../../config/config";
import { useSelector } from "react-redux";
import { usePopupManager } from "../../../providers/PopupManager/PopupManager";
import { MESSAGE_TYPE } from "../../../constants";
import axios from "axios";
import DetailedDomainTile from "../../../atomicComponents/DetailedDomainTile/DetailedDomainTile";
// import DomainTileWithSelect from "../../../atomicComponents/DomainTileWithSelect/DomainTileWithSelect";
import DashboardSection from "../../DashboardContainer/DashboardSection";
import RevenueBarChart from "../RevenueBarChart/RevenueBarChart";
import MarginBarChart from "../MarginBarChart/MarginBarChart";
import MarginGdcBarChart from "../MarginBarChart/MarginGdcBarChart";
import MarginDistributionBarChart from "../MarginBarChart/MarginDistributionBarChart";
import DomainTileDropdown from "../DomainTileDropdown/DomainTileDropdown";
import FullyLoadedBarChart from "../CostBarChart/FullyLoadedBarChart";
import CostBarLineChart from "../CostBarChart/CostBarLineChart";
import OtherCostBarLine from "../CostBarChart/OtherCostBarLine";
import AvgBarLineChart from "../CostBarChart/AvgBarLineChart";
import styles from "./FinanceMainDashboard.module.css";
import "./FinanceMainDashboard.css";
import VarinceBarChart from "../RevenueBarChart/VarianceBarChart";
import DashboardSectionDropDown from "../../DashboardContainer/DashBoardSectionDropDown";
import RevenueDoughnutChart from "./RevenueDoughnutChart";
import TileComp from "./TileComp";
import DownloadButton from "../../../atomicComponents/DownloadButton/DownloadButton";

const { API_BASE_URL } = config;

const FinanceMainDashboard = () => {
  const quarterOptionss = [
    // { value: "undefined", label: "Select" },
    // { value: "0", label: "-All-" },
    { value: "2", label: "Q1" },
    { value: "3", label: "Q2" },
    { value: "4", label: "Q3" },
    { value: "1", label: "Q4" },
  ];

  const monthOptionss = [
    { value: "1", label: "Jan" },
    { value: "2", label: "Feb" },
    { value: "3", label: "Mar" },
    { value: "4", label: "Apr" },
    { value: "5", label: "May" },
    { value: "6", label: "Jun" },
    { value: "7", label: "Jul" },
    { value: "8", label: "Aug" },
    { value: "9", label: "Sep" },
    { value: "10", label: "Oct" },
    { value: "11", label: "Nov" },
    { value: "12", label: "Dec" },
  ];

  const quarterToMonths = {
    2: ["4", "5", "6"], // Apr–Jun
    3: ["7", "8", "9"], // Jul–Sep
    4: ["10", "11", "12"], // Oct–Dec
    1: ["1", "2", "3"], // Jan–Mar
  };

  const token = useSelector((state) => state.auth.djangoAccessToken);
  const roles = useSelector((state) => state.auth.djangoRoles);
  const userInfo = useSelector((state) => state.auth.djangoUserInfo);

  const location = useLocation();
  const { showPopup } = usePopupManager();

  const [hasApplied, setHasApplied] = useState(false);

  const [showDashboard, setShowDashboard] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [entityOptions, setEntityOptions] = useState([]);
  const [yearOptions, setYearOptions] = useState([]);
  const [quarterOptions, setQuarterOptions] = useState(quarterOptionss);
  const [monthOptions, setMonthOptions] = useState(monthOptionss);
  const [towerOptions, setTowerOptions] = useState([]);
  const [costTowerOptions, setCostTowerOptions] = useState([]);
  const [marginTowerOptions, setMarginTowerOptions] = useState([]);
  const [CostElementOption, setCostElementOption] = useState([]);

  const [entity, setEntity] = useState([]);
  const [year, setYear] = useState([]);
  const [quarter, setQuarter] = useState([]);
  const [month, setMonth] = useState([]);
  const [Tower, setTower] = useState([]);
  const [costTower, setCostTower] = useState([]);
  const [marginTower, setMarginTower] = useState([]);
  // const [RevenueTower, setRevenueTower] = useState(RevenueTowerOption[0]);
  const [EmpCost, setEmpCost] = useState([]);
  const [MiscCost, setMiscCost] = useState([]);
  const [DepreCost, setDepreCost] = useState([]);
  const [OtherCost, setOtherCost] = useState();

  const [revenueData, setRevenueData] = useState([]);
  const [varianceData, setVarianceData] = useState([]);
  const [newbusinessData, setNewBusinessData] = useState([]);
  const [businessVariance, setBusinessVariance] = useState([]);
  const [totalContractData, setTotalContractData] = useState([]);
  const [totalContractVariance, setTotalContractVariance] = useState([]);
  const [avgCostData, setavgCostData] = useState([]);
  const [avgCostEmp, setAvgCostEmp] = useState([]);
  const [empCostData, setEmpCostData] = useState([]);
  const [empCostPerc, setEmpCostPerc] = useState([]);
  const [otherCostData, setOtherCostData] = useState([]);
  const [otherCostPerc, setOtherCostPerc] = useState([]);
  const [marginDistributionData, setmarginDistributionData] = useState([]);
  const [marginTMGSLData, setmarginTMGSLData] = useState([]);
  // const [gdcLabels,setGdcLabels] = useState([]);
  const [gdcDatasets, setGdcDatasets] = useState([]);
  console.log("gdcDatasets----------:",gdcDatasets)
  const [fullLoadedData, setfullLoadedData] = useState([]);
  const [revenueGrowth, setrevenueGrowth] = useState([]);
  const [dsoDomestic, setDsoDomestic] = useState("");
  const [dsoInternational, setDsoInternational] = useState("");

  const initialFilters = location.state || {
    entityData: null,
    yearData: null,
    quarterData: null,
    monthData: null,
    entityList: entityOptions,
    yearList: yearOptions,
    monthList: monthOptionss,
  };

  const [filters, setFilters] = useState(initialFilters);

  const customStyles = {
    control: (provided) => ({
      ...provided,
      minHeight: "20px",
      flexWrap: "wrap",
    }),
    valueContainer: (provided) => ({
      ...provided,
      maxHeight: "50px",
      overflowY: "auto",
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
      overflow: "visible",
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: "200px",
      overflowY: "auto",
      overflowX: "auto",
      whiteSpace: "nowrap",
    }),
    option: (provided) => ({
      ...provided,
      padding: "8px 12px",
    }),
  };

  const fetchEntityOptions = async () => {
    try {
      const response = await axios
        .get(`${API_BASE_URL}/api/finance-entity`, {
          headers: {
            // Authorization: `Bearer ${token}`,
            Authorization: "Basic YWRtaW4xOjEyMw==",
          },
        })
        .then((response) => {
          setEntityOptions(response.data);
        });
    } catch (error) {
      console.error("Error fetching finance-entity options:", error);
    }
  };

  const fetchYearOptions = async () => {
    try {
      const response = await axios
        .get(`${API_BASE_URL}/api/finance-year`, {
          headers: {
            // Authorization: `Bearer ${token}`,
            Authorization: "Basic YWRtaW4xOjEyMw==",
          },
        })
        .then((response) => {
          setYearOptions(response.data);
        });
    } catch (error) {
      console.error("Error fetching finance-year options:", error);
    }
  };

  // const fetchQuarterOptions = async () => {
  //   try {
  //     const response = await axios.get(`${API_BASE_URL}/api/finance-quarter`, {
  //       headers: {
  //         // Authorization: `Bearer ${token}`,
  //         Authorization: 'Basic YWRtaW4xOjEyMw==',
  //       },
  //     })
  //     .then((response) => {
  //       setQuarterOptions(response.data);
  //     })
  //   } catch (error) {
  //     console.error('Error fetching finance-quarter options:', error);
  //   }
  // };

  const fetchMonthOptions = async () => {
    try {
      const response = await axios
        .get(`${API_BASE_URL}/api/finance-month`, {
          headers: {
            // Authorization: `Bearer ${token}`,
            Authorization: "Basic YWRtaW4xOjEyMw==",
          },
        })
        .then((response) => {
          setMonthOptions(response.data);
        });
    } catch (error) {
      console.error("Error fetching finance-month options:", error);
    }
  };

  const fetchTowerOptions = async () => {
    try {
      const response = await axios
        .get(`${API_BASE_URL}/api/finance-tower`, {
          headers: {
            // Authorization: `Bearer ${token}`,
            Authorization: "Basic YWRtaW4xOjEyMw==",
          },
        })
        .then((response) => {
          const data = response.data;
          setTowerOptions(data);
          setCostTowerOptions(data);
          setMarginTowerOptions(data);

          if (data.length > 0) {
            setTower(data[0]);
            setCostTower(data[0]);
            setMarginTower(data[0]);
          }
        });
    } catch (error) {
      console.error("Error fetching finance-tower options:", error);
    }
  };

  const fetchCostEleOptions = async () => {
    try {
      const response = await axios
        .get(`${API_BASE_URL}/api/finance-costelement`, {
          headers: {
            // Authorization: `Bearer ${token}`,
            Authorization: "Basic YWRtaW4xOjEyMw==",
          },
        })
        .then((response) => {
          const data = response.data;
          // setTowerOptions(data);
          // setCostTowerOptions(data)
          // setMarginTowerOptions(data);
          setCostElementOption(data);
          setEmpCost(data[0]);
          setMiscCost(data[0]);
          setOtherCost(data[0]);
          setDepreCost(data[0]);
        });
    } catch (error) {
      console.error("Error fetching finance-tower options:", error);
    }
  };

  // const fetchDsoOptions = () => {
  //   axios.get(`${API_BASE_URL}/api/finance-dso`, {
  //     headers: {
  //       Authorization: "Basic YWRtaW4xOjEyMw==",
  //     },
  //   })
  //   .then((response) => {
  //     console.log("Dso Domestic and International-->",response.data)
  //     response.data.forEach((item) => {
  //       if (item.label === "Domestic") {
  //         setDsoDomestic(item.value);
  //       } else if (item.label === "International") {
  //         setDsoInternational(item.value);
  //       }
  //     });
  //   })
  //   .catch((error) => {
  //     console.error("Error fetching dso-domestic options:", error);
  //   });
  // };

  const handleEntityChange = (selected) => {
    setEntity(selected);
    setFilters((prev) => ({ ...prev, entityData: selected }));
  };

  const handleYearChange = (selected) => {
    setYear(selected);
    setFilters((prev) => ({ ...prev, yearData: selected }));
  };

  // const handleQuarterChange = (selected) => {
  //   if(selected){
  //     setQuarter(selected);
  //     setFilters(prev => ({ ...prev, quarterData: selected }));
  //   } else {
  //     setQuarter([])
  //   }

  //   if (selected?.value) {
  //     // console.log("Month Options ----->",selected?.value)
  //     setMonth(
  //       monthOptions.filter((m) =>
  //       quarterToMonths[selected.value].includes(m.value)
  //       )
  //     );
  //     setFilters(prev => ({
  //       ...prev,
  //       monthData: monthOptions.filter(m =>
  //         quarterToMonths[selected?.value]?.includes(m.value) // Safe access
  //       )
  //     }));
  //   } else {
  //     setMonth([]);
  //   }
  //   // setFilters(prev => ({ ...prev, entityData: selected }));
  // };

  const handleQuarterChange = (selected) => {
    if (selected && selected.length > 0) {
      setQuarter(selected);
      setFilters((prev) => ({ ...prev, quarterData: selected }));

      // Collect all months from selected quarters
      const selectedMonths = selected.flatMap(
        (q) => quarterToMonths[q.value] || []
      );
      // Filter available month options based on selected months
      const filteredMonths = monthOptionss.filter((m) =>
        selectedMonths.includes(m.value)
      );
      setMonth(filteredMonths);
      setFilters((prev) => ({ ...prev, monthData: filteredMonths }));
    } else {
      // No quarter selected
      setQuarter([]);
      setMonth([]);
      setFilters((prev) => ({
        ...prev,
        quarterData: [],
        monthData: [],
      }));
    }
  };

  const handleMonthChange = (selected) => {
    // setMonth(selected);
    if (selected) {
      setMonth(selected);
      setFilters((prev) => ({ ...prev, monthData: selected }));
    } else {
      setMonth([]);
    }
  };

  const handleRevenueTowerChange = (selected) => {
    setTower(selected);
    handleApply({ tower: selected });
    // setFilters(prev => ({ ...prev, entityData: selected }));
  };

  const handleEmpCostChange = (selected) => {
    setEmpCost(selected);
    handleApply({ empCost: selected });
    // setFilters(prev => ({ ...prev, entityData: selected }));
  };

  const handleMiscCostChange = (selected) => {
    setMiscCost(selected);
    handleApply({ miscCost: selected });
    // setFilters(prev => ({ ...prev, entityData: selected }));
  };

  const handleDepreCostChange = (selected) => {
    setDepreCost(selected);
    handleApply({ depreCost: selected });
    // setFilters(prev => ({ ...prev, entityData: selected }));
  };

  const handleOtherCostChange = (selected) => {
    setOtherCost(selected);
    handleApply({ otherCost: selected });
    // setFilters(prev => ({ ...prev, entityData: selected }));
  };

  const handleCostTowerChange = (selected) => {
    setCostTower(selected);
    handleApply({ costTower: selected });
  };

  const handleMarginTowerChange = (selected) => {
    setMarginTower(selected);
    handleApply({ marginTower: selected });
  };

  const handleApply = (changed = {}) => {
    const entityFilterData = entity?.map((m) => m?.value) || "";
    const yearFilterData = year?.map((m) => m?.value) || "";
    const monthFilterData = month?.map((m) => m?.value) || [];
    const quarterData = quarter?.map((m) => m?.value) || "";
    const newTower = changed.tower?.value || Tower?.value || "";
    const newCostTower = changed.costTower?.value || costTower?.value || "";
    const newMarginTower =
      changed.marginTower?.value || marginTower?.value || "";
    const empcostele = changed.empCost?.value || EmpCost?.value || "";
    const misccostele = changed.miscCost?.value || MiscCost?.value || "";
    const deprecostele = changed.depreCost?.value || DepreCost?.value || "";
    const othercostele = changed.otherCost?.value || OtherCost?.value || "";

    setFilters((prev) => ({ ...prev, entityList: entityOptions }));
    setFilters((prev) => ({ ...prev, yearList: yearOptions }));
    setFilters((prev) => ({ ...prev, monthList: monthOptionss }));

    if (Array.isArray(entity) && entity.length === 0) {
      showPopup({
        type: MESSAGE_TYPE.INFORMATION,
        contextText: MESSAGE_TYPE.INFORMATION,
        info: "Please select entity.",
      });
      return;
    }

    if (Array.isArray(year) && year.length === 0) {
      showPopup({
        type: MESSAGE_TYPE.INFORMATION,
        contextText: MESSAGE_TYPE.INFORMATION,
        info: "Please select year.",
      });
      return;
    }

    setIsLoading(true);
    const fetchRevenueData = async () => {
      try {
        const response = await axios
          .post(
            `${API_BASE_URL}/api/finance-revenue`,
            {
              selectedEntity: entityFilterData,
              selectedYear: yearFilterData,
              selectedMonth: monthFilterData,
              selectedQuarter: quarterData,
              selectedTower: newTower,
            },
            {
              headers: {
                // Authorization: `Bearer ${token}`,
                Authorization: "Basic YWRtaW4xOjEyMw==",
              },
            }
          )
          .then((response) => {
            setShowDashboard(true);
            setIsLoading(false);
            const result = response.data;
            const barData = result.barData || [];
            const revenueData = barData.slice(0, 3);
            const varianceData = barData.slice(3);
            setRevenueData(revenueData);
            setVarianceData(varianceData);
          });
      } catch (error) {
        console.error("Error fetching revenue options:", error);
      }
    };

    const fetchNewBusinessData = async () => {
      try {
        const response = await axios
          .post(
            `${API_BASE_URL}/api/finance-newbusiness`,
            {
              selectedEntity: entityFilterData,
              selectedYear: yearFilterData,
              selectedMonth: monthFilterData,
              selectedQuarter: quarterData,
              selectedTower: newTower,
            },
            {
              headers: {
                // Authorization: `Bearer ${token}`,
                Authorization: "Basic YWRtaW4xOjEyMw==",
              },
            }
          )
          .then((response) => {
            setShowDashboard(true);
            setIsLoading(false);
            const result = response.data;
            const newBusiness = result.newBusiness || [];
            const newbusinessData = newBusiness.slice(0, 3);
            const businessVariance = newBusiness.slice(3);
            setNewBusinessData(newbusinessData);
            setBusinessVariance(businessVariance);
          });
      } catch (error) {
        console.error("Error fetching new business options:", error);
      }
    };

    const fetchTotalContractData = async () => {
      try {
        const response = await axios
          .post(
            `${API_BASE_URL}/api/finance-totalcontract`,
            {
              selectedEntity: entityFilterData,
              selectedYear: yearFilterData,
              selectedMonth: monthFilterData,
              selectedQuarter: quarterData,
              selectedTower: newTower,
            },
            {
              headers: {
                // Authorization: `Bearer ${token}`,
                Authorization: "Basic YWRtaW4xOjEyMw==",
              },
            }
          )
          .then((response) => {
            setShowDashboard(true);
            setIsLoading(false);
            const result = response.data;
            const totalContract = result.totalContract || [];
            const totalContractData = totalContract.slice(0, 3);
            const totalContractVariance = totalContract.slice(3);
            setTotalContractData(totalContractData);
            setTotalContractVariance(totalContractVariance);
          });
      } catch (error) {
        console.error("Error fetching total contract value options:", error);
      }
    };

    // const fetchRevenueGrowthData = async () => {
    //   try {
    //     const response = await axios.post(`${API_BASE_URL}/api/finance-growthrate`,
    //       {
    //         selectedEntity: entityFilterData,
    //         selectedYear: yearFilterData,
    //         selectedMonth: monthFilterData,
    //         selectedQuarter: quarterData,
    //         selectedTower: newTower,
    //       },
    //       {headers: {
    //         // Authorization: `Bearer ${token}`,
    //         Authorization: 'Basic YWRtaW4xOjEyMw==',
    //       }},
    //     )
    //     .then((response) => {
    //       const result = response.data;
    //       // console.log("Finance Total Contract Data:", result);
    //       // const totalContract = result.totalContract || [];
    //       // const totalContractData = totalContract.slice(0, 3);
    //       // const totalContractVariance = totalContract.slice(3);
    //       // setrevenueGrowth(result.lenght === 0 ? 0 : result);
    //       // setTotalContractVariance(totalContractVariance);
    //       if (result && result.length > 0) {
    //         setrevenueGrowth(result);   // non-empty → use result
    //       } else {
    //         setrevenueGrowth(0);        // empty → use 0
    //       }
    //     })
    //   } catch (error) {
    //     console.error('Error fetching total contract value options:', error);
    //   }
    // };

    const fetchRevenueGrowthData = async () => {
      try {
        const response = await axios
          .post(
            `${API_BASE_URL}/api/finance-growthrate`,
            {
              selectedEntity: entityFilterData,
              selectedYear: yearFilterData,
              selectedMonth: monthFilterData,
              selectedQuarter: quarterData,
              selectedTower: newTower,
            },
            {
              headers: {
                // Authorization: `Bearer ${token}`,
                Authorization: "Basic YWRtaW4xOjEyMw==",
              },
            }
          )
          .then((response) => {
            setShowDashboard(true);
            setIsLoading(false);
            const result = response.data;
            if (result && result.length > 0) {
              // setrevenueGrowth(result[0]);
              setrevenueGrowth(result[0]?.growth_rate_percentage);
            } else {
              setrevenueGrowth(0);
            }
          });
      } catch (error) {
        console.error("Error fetching total contract value options:", error);
      }
    };

    const fetchRevenueDSOData = async () => {
      try {
        const response = await axios
          .post(
            `${API_BASE_URL}/api/finance-dso`,
            {
              selectedEntity: entityFilterData,
              selectedYear: yearFilterData,
              selectedMonth: monthFilterData,
              selectedQuarter: quarterData,
              selectedTower: newTower,
            },
            {
              headers: {
                // Authorization: `Bearer ${token}`,
                Authorization: "Basic YWRtaW4xOjEyMw==",
              },
            }
          )
          .then((response) => {
            setShowDashboard(true);
            setIsLoading(false);
            const result = response.data;
            const international = result.international;
            const domestic = result.domastic;
            // const totalContract = result.totalContract || [];
            // const totalContractData = totalContract.slice(0, 3);
            // const totalContractVariance = totalContract.slice(3);
            // setTotalContractVariance(totalContractVariance);
            setDsoDomestic(domestic);
            setDsoInternational(international);
            // setShowDashboard(true);
            // setIsLoading(false);
          });
      } catch (error) {
        console.error("Error fetching total contract value options:", error);
      }
    };

    const fetchEmployeeCostData = async () => {
      try {
        const response = await axios
          .post(
            `${API_BASE_URL}/api/finance-empcost`,
            {
              selectedEntity: entityFilterData,
              selectedYear: yearFilterData,
              selectedMonth: monthFilterData,
              selectedQuarter: quarterData,
              selectedTower: newCostTower,
              selectElement: empcostele,
            },
            {
              headers: {
                // Authorization: `Bearer ${token}`,
                Authorization: "Basic YWRtaW4xOjEyMw==",
              },
            }
          )
          .then((response) => {
            setShowDashboard(true);
            setIsLoading(false);
            const result = response.data;
            const avgCost = result.avgCost || [];
            const avgCostData = avgCost.slice(0, 3).map((item) => ({
              month: item.label,
              withinSLA: item.value,
            }));

            const datasets = [
              {
                type: "bar",
                label: "Cost of Employee",
                data: avgCostData.map((item) => Number(item.withinSLA)),
                // backgroundColor: ['#2196F3', '#FFC107', '#00BCD4'],
                backgroundColor: (ctx) => {
                  const value = ctx.raw;
                  return value < 0 ? "red" : ["#2196F3", "#FFC107", "#00BCD4"];
                },
                barThickness: 30,
                order: 1,
              },
            ];

            setavgCostData(avgCostData);
            setAvgCostEmp(datasets);
          });
      } catch (error) {
        console.error(
          "Error fetching Average Cost per employee options:",
          error
        );
      }
    };

    // const fetchMiscCostData = async () => {
    //   try {
    //     const response = await axios.post(`${API_BASE_URL}/api/finance-misccost`,
    //       {
    //         selectedEntity: entityFilterData,
    //         selectedYear: yearFilterData,
    //         selectedMonth: monthFilterData,
    //         selectedQuarter: quarterData,
    //         selectedTower: newCostTower,
    //         selectElement: misccostele
    //       },
    //       {headers: {
    //         // Authorization: `Bearer ${token}`,
    //         Authorization: 'Basic YWRtaW4xOjEyMw==',
    //       }},
    //     )
    //     .then((response) => {
    //       const result = response.data;
    //       // console.log("Finance Average Cost Data:", result);
    //       const empCost = result.empCost || [];
    //       const empCostData = empCost.slice(0, 3).map((item) => ({
    //       month: item.label,
    //       withinSLA: item.value,
    //     }));

    //       const datasets = [
    //       {
    //         type: "bar",
    //         label: "Employee Cost",
    //         data: empCostData.map((item) => Number(item.withinSLA)),
    //         backgroundColor: ['#2196F3', '#FFC107', '#00BCD4'],
    //         barThickness: 30,
    //         order: 1,
    //       },
    //     ];

    //     setEmpCostData(empCostData);
    //     setEmpCostPerc(datasets);
    //     })
    //   } catch (error) {
    //     console.error('Error fetching Employee Cost % options:', error);
    //   }
    // };

    const fetchMiscCostData = async () => {
      try {
        const response = await axios
          .post(
            `${API_BASE_URL}/api/finance-misccost`,
            {
              selectedEntity: entityFilterData,
              selectedYear: yearFilterData,
              selectedMonth: monthFilterData,
              selectedQuarter: quarterData,
              selectedTower: newCostTower,
              selectElement: misccostele,
            },
            {
              headers: {
                // Authorization: `Bearer ${token}`,
                Authorization: "Basic YWRtaW4xOjEyMw==",
              },
            }
          )
          .then((response) => {
            setShowDashboard(true);
            setIsLoading(false);
            const result = response.data;
            // console.log("Finance Average Cost Data:", result);
            //   const empCost = result.miscCost || [];
            //   const empCostData = empCost.slice(0, 3).map((item) => ({
            //   month: item.label,
            //   withinSLA: item.value,
            // }));

            //   const datasets = [
            //   {
            //     type: "bar",
            //     label: "Employee Cost",
            //     data: empCostData.map((item) => Number(item.withinSLA)),
            //     backgroundColor: ['#2196F3', '#FFC107', '#00BCD4'],
            //     barThickness: 30,
            //     order: 1,
            //   },
            // ];

            const avgCost = result.avgCost || [];
            const avgCostData = avgCost.slice(0, 3).map((item) => ({
              month: item.label,
              withinSLA: item.value,
            }));

            const datasets = [
              {
                type: "bar",
                label: "Miscellaneous Cost",
                data: avgCostData.map((item) => Number(item.withinSLA)),
                // backgroundColor: ['#2196F3', '#FFC107', '#00BCD4'],
                backgroundColor: (ctx) => {
                  const value = ctx.raw;
                  return value < 0 ? "red" : ["#2196F3", "#FFC107", "#00BCD4"];
                },
                barThickness: 30,
                order: 1,
              },
            ];

            setEmpCostData(avgCostData);
            setEmpCostPerc(datasets);
          });
      } catch (error) {
        console.error("Error fetching Employee Cost % options:", error);
      }
    };

    const fetchDepreCostData = async () => {
      try {
        const response = await axios
          .post(
            `${API_BASE_URL}/api/finance-deprecost`,
            {
              selectedEntity: entityFilterData,
              selectedYear: yearFilterData,
              selectedMonth: monthFilterData,
              selectedQuarter: quarterData,
              selectedTower: newCostTower,
              selectElement: deprecostele,
            },
            {
              headers: {
                // Authorization: `Bearer ${token}`,
                Authorization: "Basic YWRtaW4xOjEyMw==",
              },
            }
          )
          .then((response) => {
            setShowDashboard(true);
            setIsLoading(false);
            const result = response.data;
            // console.log("Finance Distribution Data :", result);
            const fullLoaded = result.fullLoaded || [];
            const fullLoadedData = fullLoaded.slice(0, 3);
            setfullLoadedData(fullLoadedData);
          });
      } catch (error) {
        console.error("Error fetching Distribution options:", error);
      }
    };

    const fetchOtherCostData = async () => {
      try {
        const response = await axios
          .post(
            `${API_BASE_URL}/api/finance-othercost`,
            {
              selectedEntity: entityFilterData,
              selectedYear: yearFilterData,
              selectedMonth: monthFilterData,
              selectedQuarter: quarterData,
              selectedTower: newCostTower,
              selectElement: othercostele,
            },
            {
              headers: {
                // Authorization: `Bearer ${token}`,
                Authorization: "Basic YWRtaW4xOjEyMw==",
              },
            }
          )
          .then((response) => {
            setShowDashboard(true);
            setIsLoading(false);
            const result = response.data;
            const otherCost = result.otherCost || [];
            const otherCostData = otherCost.slice(0, 3).map((item) => ({
              month: item.label,
              withinSLA: item.value,
            }));

            const datasets = [
              {
                type: "bar",
                label: "Other Cost",
                data: otherCostData.map((item) => Number(item.withinSLA)),
                // backgroundColor: ['#2196F3', '#FFC107', '#00BCD4'],
                backgroundColor: (ctx) => {
                  const value = ctx.raw;
                  return value < 0 ? "red" : ["#2196F3", "#FFC107", "#00BCD4"];
                },
                barThickness: 30,
                order: 1,
              },
            ];

            setOtherCostData(otherCostData);
            setOtherCostPerc(datasets);
          });
      } catch (error) {
        console.error("Error fetching Distribution options:", error);
      }
    };

    const fetchDistributionData = async () => {
      try {
        const response = await axios
          .post(
            `${API_BASE_URL}/api/finance-distribution`,
            {
              selectedEntity: entityFilterData,
              selectedYear: yearFilterData,
              selectedMonth: monthFilterData,
              selectedQuarter: quarterData,
              selectedTower: newMarginTower,
            },
            {
              headers: {
                // Authorization: `Bearer ${token}`,
                Authorization: "Basic YWRtaW4xOjEyMw==",
              },
            }
          )
          .then((response) => {
            setShowDashboard(true);
            setIsLoading(false);
            const result = response.data;
            const distribution = result.distribution || [];
            const marginDistributionData = distribution.slice(0, 3);
            setmarginDistributionData(marginDistributionData);
          });
      } catch (error) {
        console.error("Error fetching Margin Distribution options:", error);
      }
    };

    const fetchTMGSLData = async () => {
      try {
        const response = await axios
          .post(
            `${API_BASE_URL}/api/finance-TMGSL`,
            {
              selectedEntity: entityFilterData,
              selectedYear: yearFilterData,
              selectedMonth: monthFilterData,
              selectedQuarter: quarterData,
              selectedTower: newMarginTower,
            },
            {
              headers: {
                // Authorization: `Bearer ${token}`,
                Authorization: "Basic YWRtaW4xOjEyMw==",
              },
            }
          )
          .then((response) => {
            setShowDashboard(true);
            setIsLoading(false);
            const result = response.data;
            const distribution = result.distribution || [];
            const marginDistributionData = distribution.slice(0, 3);
            setmarginTMGSLData(marginDistributionData);
          });
      } catch (error) {
        console.error("Error fetching Margin Distribution options:", error);
      }
    };

    const fetchGDCData = async () => {
      try {
        const response = await axios
          .post(
            `${API_BASE_URL}/api/finance-gdc`,
            {
              selectedEntity: entityFilterData,
              selectedYear: yearFilterData,
              selectedMonth: monthFilterData,
              selectedQuarter: quarterData,
              selectedTower: newMarginTower,
            },
            {
              headers: {
                // Authorization: `Bearer ${token}`,
                Authorization: "Basic YWRtaW4xOjEyMw==",
              },
            }
          )
          .then((response) => {
            setShowDashboard(true);
            setIsLoading(false);
            const result = response.data;
            const marginGDC = result.marginGDC || [];
            setGdcDatasets(marginGDC);
          });
      } catch (error) {
        console.error("Error fetching Margin GDC options:", error);
      }
    };

    // Promise.all([fetchRevenueData(),fetchNewBusinessData(),fetchTotalContractData(),fetchRevenueGrowthData(),fetchDistributionData(),fetchDepreCostData(),fetchEmployeeCostData(),fetchMiscCostData(),fetchOtherCostData(),fetchGDCData(),fetchTMGSLData(),fetchRevenueDSOData()]).then(() => {
    //   setShowDashboard(true);
    //   setIsLoading(false);
    // });
      
      fetchRevenueData();
      fetchNewBusinessData();
      fetchTotalContractData();
      fetchRevenueGrowthData();
      fetchDistributionData();
      fetchDepreCostData();
      fetchEmployeeCostData();
      fetchMiscCostData();
      fetchOtherCostData();
      fetchGDCData();
      fetchTMGSLData();      
      fetchRevenueDSOData();
  };

  const MarginGDCDatasets = [
    {
      type: "bar",
      label: "Annual Target",
      data: gdcDatasets.map((d) => d.Annual_Target),
      // backgroundColor: "#2196F3",
      backgroundColor: (ctx) => {
        const value = ctx.raw;
        return value < 0 ? "red" : "#2196F3";
      },
      // stack: "combined",
      order: 1,
      // barThickness: 15,
      barPercentage: 0.5,
      categoryPercentage: 0.7,
    },
    {
      type: "bar",
      label: "YTD Target",
      data: gdcDatasets.map((d) => d.YTD_Target),
      // backgroundColor: "#FFC107",
      backgroundColor: (ctx) => {
        const value = ctx.raw;
        return value < 0 ? "red" : "#FFC107";
      },
      // stack: "combined",
      order: 1,
      // barThickness: 15,
      barPercentage: 0.5,
      categoryPercentage: 0.7,
    },
    {
      type: "bar",
      label: "Actual",
      data: gdcDatasets.map((d) => d.Actual),
      // backgroundColor: "#00BCD4",
      backgroundColor: (ctx) => {
        const value = ctx.raw;
        return value < 0 ? "red" : "#00BCD4";
      },
      // stack: "combined",
      order: 1,
      // barThickness: 15,
      barPercentage: 0.5,
      categoryPercentage: 0.7,
    },
  ];

  console.log("MarginGDCDatasets---------:",MarginGDCDatasets);

  const handleReset = () => {
    setEntity(null);
    setYear(null);
    setQuarter(null);
    setMonth(null);
    setTower(towerOptions[0]);
    setCostTower(costTowerOptions[0]);
    setMarginTower(marginTowerOptions[0]);
    setFilters({
      entityData: null,
      yearData: null,
      quarterData: null,
      monthData: null,
    });
    setRevenueData([]);
    setVarianceData([]);
    setNewBusinessData([]);
    setBusinessVariance([]);
    setTotalContractData([]);
    setTotalContractVariance([]);
    setavgCostData([]);
    setAvgCostEmp([]);
    setEmpCostData([]);
    setEmpCostPerc([]);
    setOtherCostData([]);
    setOtherCostPerc([]);
    setmarginDistributionData([]);
    // setGdcLabels([]);
    setGdcDatasets([]);
    setfullLoadedData([]);
    setShowDashboard(false);
  };

  useEffect(() => {
    fetchEntityOptions();
    fetchYearOptions();
    // fetchQuarterOptions();
    fetchMonthOptions();
    fetchTowerOptions();
    fetchCostEleOptions();
    // fetchDsoOptions();
  }, []);

  useEffect(() => {
    if (
      entityOptions.length &&
      yearOptions.length &&
      monthOptions.length &&
      quarterOptions.length
    ) {
      let shouldApply = false;

      if (filters.entityData) {
        // const ent = entityOptions.find(opt => opt.value === filters.entityData.value);
        // if (ent) {
        //   setEntity(ent);
        //   shouldApply = true;
        // }
        const ent = entityOptions.filter((opt) =>
          filters.entityData.some((m) => m.value === opt.value)
        );
        if (ent.length > 0) {
          setEntity(ent);
          shouldApply = true;
        }
      }

      if (filters.yearData) {
        // const yr = yearOptions.find(opt => opt.value === filters.yearData.value);
        // if (yr) {
        //   setYear(yr);
        //   shouldApply = true;
        // }
        const ent = yearOptions.filter((opt) =>
          filters.yearData.some((m) => m.value === opt.value)
        );
        if (ent.length > 0) {
          setYear(ent);
          shouldApply = true;
        }
      }

      if (filters.monthData && filters.monthData.length > 0) {
        const mon = monthOptionss.filter((opt) =>
          filters.monthData.some((m) => m.value === opt.value)
        );
        if (mon.length > 0) {
          setMonth(mon);
          shouldApply = true;
        }
      }

      if (filters.quarterData && filters.quarterData.length > 0) {
        const qtr = quarterOptionss.filter((opt) =>
          filters.quarterData.some((m) => m.value === opt.value)
        );
        if (qtr.length > 0) {
          setQuarter(qtr);
          shouldApply = true;
        }
      }

      if (shouldApply) {
        setHasApplied(true);
      }

      setTower({ label: "Overall", value: "Overall" });
      setCostTower({ label: "Overall", value: "Overall" });
      setMarginTower({ label: "Overall", value: "Overall" });
      setEmpCost({ label: "Overall", value: "Overall" });
      setMiscCost({ label: "Overall", value: "Overall" });
      setDepreCost({ label: "Overall", value: "Overall" });
      setOtherCost({ label: "Overall", value: "Overall" });
    }
  }, [entityOptions, yearOptions, monthOptions, quarterOptions]);

  useEffect(() => {
    if (hasApplied === true) {
      handleApply();
      setHasApplied(false);
    }
  }, [hasApplied]);

  const emeraldGradient = "linear-gradient(135deg, #10B981 0%, #0D9488 100%)";
  const amberGradient = "linear-gradient(135deg, #FBBF24 0%, #F97316 100%)";

  const downloadDataDyanmically = async (changed = {},name) => {
    console.log("click to download",name);
    try {
      const entityFilterData = entity?.map((m) => m?.value) || "";
      const yearFilterData = year?.map((m) => m?.value) || "";
      const monthFilterData = month?.map((m) => m?.value) || [];
      const quarterData = quarter?.map((m) => m?.value) || "";
      const newTower = changed.tower?.value || Tower?.value || "";
      const newCostTower = changed.costTower?.value || costTower?.value || "";
      const newMarginTower = changed.marginTower?.value || marginTower?.value || "";
      const empcostele = changed.empCost?.value || EmpCost?.value || "";
      const misccostele = changed.miscCost?.value || MiscCost?.value || "";
      const deprecostele = changed.depreCost?.value || DepreCost?.value || "";
      const othercostele = changed.otherCost?.value || OtherCost?.value || "";
      const bodyData = {
        entity: entityFilterData,
        year: yearFilterData,
        month: monthFilterData,
        quater: quarterData,
        tower: newTower,
        costtower: newCostTower,
        empele: empcostele,
        missele: misccostele,
        depriele: deprecostele,
        otherele: othercostele,
        report:name,
        application:"Finance"
      };

      const response = await fetch(`${API_BASE_URL}/api/download-data`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: 'Basic YWRtaW4xOjEyMw==',
        },
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        throw new Error("Failed to download CSV");
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${name}_data.csv`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download error:", error);
    }
  }

  return (
    <>
      <div className={styles.filter_panel_container}>
        <div className={styles.filter_panel_row}>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>
              Entity <span style={{ color: "red" }}>*</span>
            </label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={entity}
                onChange={handleEntityChange}
                options={entityOptions}
                isSearchable={true}
                isMulti={true}
                closeMenuOnSelect={false}
                styles={customStyles}
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>
              Year <span style={{ color: "red" }}>*</span>
            </label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={year}
                onChange={handleYearChange}
                options={yearOptions}
                isSearchable={true}
                isMulti={true}
                closeMenuOnSelect={false}
                styles={customStyles}
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Quarter</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={quarter}
                onChange={handleQuarterChange}
                options={quarterOptionss}
                isSearchable={true}
                isMulti={true}
                closeMenuOnSelect={false}
                styles={customStyles}
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Month</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={month}
                onChange={handleMonthChange}
                options={monthOptionss}
                isSearchable={true}
                isMulti={true}
                closeMenuOnSelect={false}
                styles={customStyles}
              />
            </div>
          </div>
          <div className="filter-panel-col action-buttons">
            <button onClick={handleApply} className="btn apply-btn">
              Apply
            </button>
            <button onClick={handleReset} className="btn reset-btn">
              Reset
            </button>
          </div>
        </div>
      </div>

      {isLoading && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            zIndex: 9999,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <div className="text-center">
            <div className="spinner-border text-primary mb-3" role="status"></div>
            <p className="mb-3" style={{ fontSize: "18px", fontWeight: "bold", color: "#0067ac" }}>Loading...</p>
            
          </div>
        </div>
      )}
      {showDashboard && (
      <>
        <div>
          <div className="row">
            <div className="col-lg-12">
              <div className="domain-tile">
                <div className="domain-tile-header">Revenue</div>
                <div className={styles.filter_panel_col}>
                  <div className={styles.filter_select_wrapper_50}>
                    <Select
                      value={Tower}
                      onChange={handleRevenueTowerChange}
                      options={towerOptions}
                      isSearchable={false}
                    />
                  </div>
                </div>
              </div>
              <div>
                <div className="row">
                  <div className="col-lg-8">
                    <DashboardSection
                      title=""
                      disableDetailView={false}
                      detailPath={"/Finance-Page/Revenue-Business"}
                      detailState={filters}
                      // infoIcondata={"Manual CSV + SAP DATA"}S
                    >
                      <div className="row">
                        <div className="col-lg-6">
                          <div className="row">
                          <div className="col-lg-8">
                            <div className={styles.revenue}>Revenue</div>
                          <RevenueBarChart data={revenueData} />
                          </div>
                            <div className="col-lg-4">
                              {/* <div className={styles.revenue}></div> */}
                              <div className="d-flex w-100 align-items-end justify-content-end">
                            <DownloadButton
                            onClick={() => downloadDataDyanmically({}, "Revenue")}
                            color="green" />
                          </div>
                              <div className="mt-3">
                                <VarinceBarChart data={varianceData} />
                                </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="row">
                            <div className="col-lg-8">
                            <div className={styles.revenue}>
                                New Business(# Resources)
                              </div>
                              <RevenueBarChart data={newbusinessData} />
                            </div>
                            <div className="col-lg-4">
                              {/* <div className={styles.revenue}></div> */}
                              <div className="d-flex w-100 align-items-end justify-content-end">
                            <DownloadButton 
                            onClick={() => downloadDataDyanmically({}, "New Business")}
                            color="green" />
                          </div>
                              <div className="mt-3">
                                <VarinceBarChart data={businessVariance} />
                                </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </DashboardSection>
                  </div>

                  <div className="col-lg-4">
                    <DashboardSection
                      title="Revenue Growth"
                      disableDetailView={true}
                      infoIcondata={"Manual CSV DATA"}
                    >
                      <RevenueDoughnutChart
                        percentage={revenueGrowth}
                        title="Revenue Growth"
                      />
                    </DashboardSection>
                  </div>
                </div>

                <div className="mt-2">
                  <DetailedDomainTile
                    title="Total Contract Value and DSO"
                    showButton={true}
                    path="/Finance-Page/Total-Contract-Value-DSO"
                    detailState={filters}
                    infoIcondata={"Manual CSV + SAP DATA"}
                  />
                  <div className="row">
                    <div className="col-lg-8 mt-1">
                      <DashboardSection
                        title="Total Contract Value"
                        disableDetailView={true}
                      >
                        <div className="row">
                          <div className="col-lg-8">
                            <RevenueBarChart data={totalContractData} />
                          </div>
                          <div className="col-lg-4">
                            <VarinceBarChart data={totalContractVariance} />
                          </div>
                        </div>
                      </DashboardSection>
                    </div>
                    <div className="col-lg-4 mt-1">
                      <div className="row">
                        <div className="col-lg-12">
                          <TileComp
                            title="Domestic"
                            number={`${dsoDomestic} Days`}
                            gradient={emeraldGradient}
                            popupContent="This metric is SAP Based"
                          />
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-lg-12 mt-3">
                          <TileComp
                            title="International"
                            number={`${dsoInternational} Days`}
                            gradient={amberGradient}
                            popupContent="This metric is SAP Based"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row mt-2">
                <div className="col-lg-12 mt-1">
                  <div className="row">
                    <div className="col-12">
                      <div className="domain-tile">
                        <div className="domain-tile-header">Margin</div>
                        <div className={styles.filter_panel_col}>
                          <div className={styles.filter_select_wrapper_50}>
                            <Select
                              value={marginTower}
                              onChange={handleMarginTowerChange}
                              options={marginTowerOptions}
                              isSearchable={false}
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-6">
                      <DashboardSection
                        title="Margin - TMGSL"
                        disableDetailView={false}
                        detailPath={"/Finance-Page/Margin-TMGSL"}
                        detailState={filters}
                        // infoIcondata={"Manual CSV DATA"}
                      >
                        <MarginBarChart data={marginTMGSLData} />
                      </DashboardSection>
                    </div>

                    <div className="col-lg-6">
                      <DashboardSection
                        title="Margin"
                        disableDetailView={false}
                        detailPath={"/Finance-Page/Margin-Gdc-Distribution"}
                        detailState={filters}
                        // infoIcondata={"Manual CSV DATA"}
                      >
                        <div className="row">
                          <div className="col-lg-6">
                            <div className={styles.margin}>GDC</div>
                            {/* <MarginGdcBarChart
                              labels={gdcDatasets}
                              datasets={MarginGDCDatasets}
                            /> */}
                            <MarginDistributionBarChart
                              data={gdcDatasets}
                            />
                          </div>
                          <div className="col-lg-6">
                            <div className={styles.margin}>Distribution</div>
                            <MarginDistributionBarChart
                              data={marginDistributionData}
                            />
                          </div>
                        </div>
                      </DashboardSection>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row mt-2">
                <div className="col-lg-12">
                  <div className="row">
                    <div className="col-lg-12 mt-2">
                      <DomainTileDropdown
                        title="Cost"
                        costValue={costTower}
                        setCostValue={handleCostTowerChange}
                        costOptions={costTowerOptions}
                        showButton={true}
                        path="/Finance-Page/Finance-Cost"
                        detailState={filters}
                        infoIcondata={"Manual CSV + SAP DATA"}
                      />
                    </div>
                    <div className="col-lg-6 ">
                      <DashboardSectionDropDown
                        title="Employee Cost"
                        disableDetailView
                        showDownloadView
                        CostElement={EmpCost}
                        onDownload={(t) => downloadDataDyanmically({},t)}
                        handleCostElementChange={handleEmpCostChange}
                        CostElementOption={CostElementOption}
                      >
                        <AvgBarLineChart
                          datasets={avgCostEmp}
                          chartData={avgCostData}
                        />
                      </DashboardSectionDropDown>
                    </div>
                    <div className="col-lg-6 ">
                      <DashboardSectionDropDown
                        title="Miscellaneous Cost"
                        disableDetailView
                        showDownloadView
                        CostElement={MiscCost}
                        onDownload={(t) => downloadDataDyanmically({},t)}
                        handleCostElementChange={handleMiscCostChange}
                        CostElementOption={CostElementOption}
                      >
                        <CostBarLineChart
                          datasets={empCostPerc}
                          chartData={empCostData}
                        />
                      </DashboardSectionDropDown>
                    </div>
                    <div className="col-lg-6 mt-2">
                      <DashboardSectionDropDown
                        title="Depreciation and Amortization"
                        disableDetailView
                        showDownloadView
                        CostElement={DepreCost}
                        onDownload={(t) => downloadDataDyanmically({},t)}
                        handleCostElementChange={handleDepreCostChange}
                        CostElementOption={CostElementOption}
                      >
                        <FullyLoadedBarChart data={fullLoadedData} />
                      </DashboardSectionDropDown>
                    </div>
                    <div className="col-lg-6 mt-2">
                      <DashboardSectionDropDown
                        title="Other Cost"
                        disableDetailView
                        showDownloadView
                        CostElement={OtherCost}
                        onDownload={(t) => downloadDataDyanmically({},t)}
                        handleCostElementChange={handleOtherCostChange}
                        CostElementOption={CostElementOption}
                      >
                        <OtherCostBarLine
                          datasets={otherCostPerc}
                          chartData={otherCostData}
                        />
                      </DashboardSectionDropDown>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-2">
          <span style={{ color: "red", fontSize: "12px" }}>
            NOTE : Red Color Indicates Negative Values in Charts *
          </span>
        </div>
      </>
      )}
    </>
  );
};

export default FinanceMainDashboard;
